import { z } from 'zod';

export const VERSION_PARAM = 'v';

// Query param values have been formatted to lowercase
export enum QP_VALUE {
  CREATE_JOB = 'createjob',
  COPY_JOB = 'copyjob',
  EDIT_DRAFT = 'editdraft',
}

export const defaultQueryParams: QueryParams = {};

export const POSTED_JOB_ID = 'postedjobid';

export const QueryParamsSchema = z
  .object({
    advertiserid: z.string(),
    draftid: z.string(),
    jobid: z.string(),
    referrer: z.string(),
    promocodes: z.string(),
    [VERSION_PARAM]: z.string(),
  })
  .partial();

export type QueryParams = z.infer<typeof QueryParamsSchema>;
